<template>
    <Trombinoscope
     Title="Développement web" 
     :projects="webDevelopmentProjects" 
     baseRoute="/portfolio/developpement-web"
     />
</template>






<script>


import Trombinoscope from '@/components/Trombinoscope.vue';

export default {
  components: {
    Trombinoscope,
  },
  data() {
    return {
      webDevelopmentProjects: [
      {
          nom: 'Site Quantum',
          description: "Site web de vente de bière",
          background: '/img/projet/quantum.jpg',
          date:"Juin 2024",
          skills:['php.png','css.svg','js.svg','filezilla.png','vscode.png']
        },
        { 
          nom: 'Site Eh Connard!',
           description: 'Site web féministe', 
           background: '/img/projet/ehConnard.jpg',
           date:"Janvier 2024",
           skills:['php.png','css.svg','vscode.png']
          },
          { 
          nom: 'Shanks Website',
           description: 'Site web consacré au personnage de Shanks dans One Piece', 
           background: '/img/projet/shanksSite.jpg',
           date:"Avril 2024",
           skills:['html.svg','css.svg','js.svg','vscode.png']
          },
          { 
          nom: 'Films du moment',
           description: 'Page web présentant les films du moment', 
           background: '/img/projet/filmDuMoment.jpg',
           date:"Mars 2024",
           skills:['html.svg','css.svg','vscode.png']
          },
          { 
           nom: 'Site WordPress',
           description: 'Site WordPress sur le thème du jeu-vidéo', 
           background: '/img/projet/themeWordPress.jpg',
           date:"Janvier 2025",
           skills:['wordpress.png','vscode.png','canva.png']
          },
          {
           nom: 'Landing Page',
           description: "Landing page du site de l'IUT Sénart-Fontainebleau", 
           background: '/img/projet/landingPage.jpg',
           date:"Novembre 2024",
           skills:['html.svg','css.svg','vscode.png','js.svg']
          },
          { 
           nom: "Site Next.Us",
           description: "Site de l'association Next.Us", 
           background: '/img/projet/site-nextus.png',
           date:"Mars 2026",
           skills:['wordpress.png','vscode.png']
          },
      ],
    };
  },
};



</script>